export const DepartmentIndexSceneTranslation = {
  fi: {
    DepartmentIndexScene: {
      title: 'Osastot',
      create: 'Luo uusi osasto',
      emptyText: 'Voit lisätä uuden osaston sivun oikeasta ylälaidasta.',
    },
  },
};
